export default __webpack_public_path__ + "static/media/close.3af958a6.svg";